<template>
  <div
    class="mr-3"
  >
    <button
      type="button"
      :class="['btn btnclass smallerfontsize', addSelectedClass]"
      @click="fieldData.showTitleModal = true"
    >
      Title
    </button>
    <b-modal
      v-model="fieldData.showTitleModal"
      :no-close-on-backdrop="true"
      size="md"
      title="Title"
      @shown="popupIsShown"
      @hide="popupIsHidden"
      @ok="saveTitle"
    >
      <div
        class="wcDiv"
      >
        <label class="wlabel">
          Wildcard support
          <b-form-checkbox
            id="with_wildcards"
            v-model="isWildcardSearch"
            size="sm"
            type="checkbox"
            class="wCheckbox"
          /></label>
      </div>
      <b-form-input
        v-model="title_search"
        placeholder="title"
        size="sm"
        autofocus
      />
      <div class="explanation mt-2">
        Enter title or title code in one of the following example formats:
      </div>
      <div class="explanation">
        Sportnytt, Sport*, *nytt, *ortny*. Separate with commas if more than one title, e.g. "rapport, aktuellt"
      </div>
      <template #modal-footer="{ cancel, ok }">
        <b-button
          size="sm"
          variant="outline-secondary"
          @click="cancel()"
        >
          Cancel
        </b-button>
        <b-button
          size="sm"
          variant="primary"
          @click="ok()"
        >
          Save
        </b-button>
      </template>
    </b-modal>
  </div>
</template>
  
  <script>
 
  export default {
    name: "TitleModal",
    props: {
    fieldData: Object
  },
    data() {
      return {
        title_search: "",
        isWildcardSearch: true
      };
    },
    computed: {
      addSelectedClass() {
        let selectedClass = "";
        let query = this.$store.getters['searchApiBody/getPayload'];
        if (query.title_search) selectedClass = "selected";
        return selectedClass;
      }
    },
    methods: {
      popupIsShown() {
        document.addEventListener("keyup", this.onKeyUp);
        let query = this.$store.getters['searchApiBody/getPayload'];
        this.isWildcardSearch = query.isWildcard;
        this.title_search = query.title_search;
      },
      onKeyUp(event) {
        if (event.key === "Enter" && this.fieldData.showTitleModal) {
          this.saveTitle();
          this.fieldData.showTitleModal = false;
        }
      },
      popupIsHidden() {
        document.removeEventListener("keyup", this.onKeyUp);
      },
      saveTitle() {
        const updatedQuery = {
          ...this.$store.getters['searchApiBody/getPayload'],
          title_search: this.title_search,
          isWildcard: this.isWildcardSearch
        };
        this.$store.commit(
          'searchApiBody/updatePayload',
          updatedQuery,
        );
      }
    }
  };
  </script>
  
  <style scoped>
  input {
    height: 30px !important;
    box-sizing: border-box;
    border: 1px solid #ced4da;
    padding: 2px 5px !important;
  }
  
  .wcDiv {
    float: right;
    margin-top: 8px;
    height: 13px;
  }
  
  .wlabel {
    float: right;
    margin: 0px;
    font-weight: normal;
    font-size: xx-small;
  }
  .wInfo {
    transform: scale(1.4);
    margin-left: 2px;
  }
  .wCheckbox {
    float: right;
    margin-top: -5px;
    margin-left: 5px;
    transform: scale(0.9);
  }
  </style>
  